module.exports = __webpack_public_path__ + "img/f42821b40ce6d040fb133553ea3c6139.png";